var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 2H2.8a.8.8 0 0 0-.8.8v13.6a.8.8 0 0 0 .8.8h13.6a.8.8 0 0 0 .8-.8V2.8a.8.8 0 0 0-.8-.8zm-.8 13.6h-12v-12h12v12zM20.4 18.4v2h-2V22h2.8a.8.8 0 0 0 .8-.8v-2.8h-1.6zM12.248 20.4h4.304V22h-4.304zM8.4 20.4v-2H6.8v2.8a.8.8 0 0 0 .8.8h2.8v-1.6h-2zM21.2 6.8h-2.8v1.6h2v2H22V7.6a.8.8 0 0 0-.8-.8zM20.4 12.248H22v4.304h-1.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateDashboard);
export default __webpack_public_path__ + "static/media/duplicate-dashboard.5dbfb6a8f8d8b563377b30c9d19143bb.svg";
export { ForwardRef as ReactComponent };